import { Integration } from "@/components/home/Integration/tabs-integration/IntegrationsData";
import Image from "next/image";
import { FC } from "react";

interface IntegrationContentProps {
  tabId: string;
  label: string;
  listData: Integration[];
}

const IntegrationContent: FC<IntegrationContentProps> = ({
  tabId,
  label,
  listData,
}) => (
  <div key={tabId} className="col-span-2 flex flex-col gap-3 md:col-span-1">
    <div>
      <div className="flex flex-col gap-1">
        <h4 id={tabId} className="text-[14px] font-medium text-[#202020]">
          {label}
        </h4>
        {listData.map((item) => (
          <a
            href={item.url}
            rel="noreferrer"
            key={item.id}
            className="flex w-fit items-center gap-2"
          >
            <Image src={item.icon} alt={item.title} className="w-[2rem]" />
            <p className="text-[14px] font-normal text-[#484848] transition-colors duration-300">
              <span>{item.title}</span>
            </p>
          </a>
        ))}
      </div>
    </div>
  </div>
);
export default IntegrationContent;
